export default __webpack_public_path__ + "static/differential-scroll-03-d3f9e107f034e4f9d79b223bc1d9ad7d.jpg";